import { CSSProperties } from 'react';

export const chatStyles = {
  wrapper: {
    display: 'flex',
    height: '100vh',
    backgroundColor: '#0D0D0D',
    color: '#FFFFFF',
  },

  sidebar: {
    width: '260px',
    borderRight: '1px solid #2D2D2D',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  navbar: {
    height: '60px',
    borderBottom: '1px solid #2D2D2D',
    padding: '0 20px',
    display: 'flex',
    alignItems: 'center',
  },

  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },

  chatContainer: {
    flex: 1,
    overflowY: 'auto',
    paddingBottom: '100px',
  },

  messageIcon: {
    width: '32px',
    height: '32px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  codeBlock: {
    margin: '12px 0',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundColor: '#121418',
    border: '1px solid rgba(255, 255, 255, 0.08)',
  },

  codeLanguage: {
    padding: '8px 12px',
    backgroundColor: 'transparent',
    color: '#A1A1AA',
    fontSize: '12px',
  },

  pre: {
    margin: 0,
    padding: '12px',
    overflow: 'auto',
  },

  codeHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 14px',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
    color: '#A1A1AA',
    fontSize: '11.5px',
    fontWeight: 500,
    letterSpacing: '0.02em',
    textTransform: 'lowercase',
  },

  codeActions: {
    display: 'flex',
    gap: '8px',
  },

  copyButton: {
    padding: '4px 10px',
    fontSize: '11.5px',
    fontWeight: 500,
    backgroundColor: 'transparent',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '7px',
    color: '#A1A1AA',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
  },

  inputArea: {
    position: 'fixed',
    bottom: 0,
    left: '260px',
    right: 0,
    padding: '20px',
    backgroundColor: '#0D0D0D',
    borderTop: '1px solid #2D2D2D',
  },

  inputWrapper: {
    maxWidth: '800px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  textInputContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    backgroundColor: '#1E1E1E',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #2D2D2D',
  },

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  icon: {
    padding: '4px',
    cursor: 'pointer',
    color: '#888',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  textInput: {
    flex: 1,
    border: 'none',
    backgroundColor: 'transparent',
    color: '#FFFFFF',
    fontSize: '14px',
    resize: 'none',
    outline: 'none',
    minHeight: '24px',
    maxHeight: '150px',
    width: '100%',
  },

  sendButton: {
    padding: '6px 12px',
    backgroundColor: '#10A37F',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
  },

  fileIndicator: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 8px',
    backgroundColor: '#2D2D2D',
    borderRadius: '4px',
    fontSize: '12px',
    color: '#CCC',
  },

  bottomText: {
    textAlign: 'center',
    color: '#888',
    fontSize: '12px',
  },

  newChatButton: {
    padding: '8px 12px',
    backgroundColor: '#2D2D2D',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    width: '100%',
  },

  conversationItem: {
    padding: '8px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  selectedConversation: {
    backgroundColor: '#2D2D2D',
  },

  conversationTitleWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  conversationTitle: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  editButton: {
    padding: '4px',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#888',
    cursor: 'pointer',
    display: 'none',
  },

  deleteButton: {
    padding: '4px 8px',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#888',
    cursor: 'pointer',
    fontSize: '16px',
  },

  titleInput: {
    width: '100%',
    padding: '4px 8px',
    backgroundColor: '#1E1E1E',
    border: '1px solid #2D2D2D',
    borderRadius: '4px',
    color: 'white',
    fontSize: '14px',
  },

  modelSelect: {
    padding: '6px 12px',
    backgroundColor: '#1E1E1E',
    color: 'white',
    border: '1px solid #2D2D2D',
    borderRadius: '6px',
    fontSize: '14px',
  },

  generatedImageContainer: {
    margin: '1rem 0',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
    backgroundColor: '#1E1E1E',
    border: '1px solid #2D2D2D',
    maxWidth: '100%',
  },

  generatedImage: {
    display: 'block',
    maxWidth: '100%',
    height: 'auto',
  },

  generatedImageHeader: {
    padding: '10px 16px',
    backgroundColor: '#2D2D2D',
    color: '#CCC',
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
} as const; 